import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";
import moment from "moment";

@Pipe({
  name: "dateFormat",
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
  transform(date: string | Date, format: string = 'DDMMYYYY'): any {
    if (date) {
      return moment(date, format).format("DD/MM/YYYY");
    } else {
      return "";
    }
  }
}
